import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["height"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  id: "Path_7615",
  "data-name": "Path 7615",
  d: "M0,0H24V24H0Z",
  fill: "none"
}, null, -1)


export default /*#__PURE__*/_defineComponent({
  __name: 'IconAdd',
  props: {
    className: {},
    classStroke: {},
    size: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    id: "Component_626_1",
    class: _normalizeClass(_ctx.className),
    "data-name": "Component 626 – 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: _ctx.size || 24,
    viewBox: "0 0 24 24"
  }, [
    _hoisted_2,
    _createElementVNode("line", {
      id: "Line_532",
      class: _normalizeClass(`${_ctx.classStroke} svg-stroke`),
      "data-name": "Line 532",
      y2: "14",
      transform: "translate(12 5)",
      fill: "none",
      stroke: "#adb2b8",
      "stroke-linejoin": "round",
      "stroke-width": "2"
    }, null, 2),
    _createElementVNode("line", {
      id: "Line_533",
      class: _normalizeClass(`${_ctx.classStroke} svg-stroke`),
      "data-name": "Line 533",
      x2: "14",
      transform: "translate(5 12)",
      fill: "none",
      stroke: "#adb2b8",
      "stroke-linejoin": "round",
      "stroke-width": "2"
    }, null, 2)
  ], 10, _hoisted_1))
}
}

})